import {StatesItemType} from 'types/locationType';

/**
 * Perform searching of received state in list of approved state and returns result
 * @param {Array<StatesItemType>} states - Received states for search
 * @param {string} shortName - State ID for searching
 * @param {string} longName -  State name used when searching is failed
 * @returns {DeliveryStepFormFieldType} - Returned address component for specified field
 */
export const getStatesModifier = (
    states: Array<StatesItemType>,
    {longName, shortName}: {shortName: string; longName: string},
) => {
    const result = {
        regionID: {
            error: false,
            success: true,
            value: '',
        },
        state: {
            error: false,
            success: true,
            value: longName,
        },
    };

    if (states.length) {
        const suitableState = states.find((state: StatesItemType) => state.value === shortName);
        result.state.value = suitableState ? suitableState.label : '0';
        result.regionID.value = suitableState ? suitableState.id : '';
    }
    return result;
};
